import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { Navigation } from 'lucide-react';
import {
  OSM_ATTRIBUTION,
  OSM_TILE_URL,
  directionsUrl,
  hasExactLocation,
  truckPinIcon,
} from '../lib/truckLocation';

export default function TruckLocationMap({ location, className = 'h-48' }) {
  if (!hasExactLocation(location)) return null;
  const position = [Number(location.lat), Number(location.lng)];

  return (
    <div className="space-y-2" data-testid="truck-location-map">
      <div className={`relative isolate z-0 rounded-xl overflow-hidden border ${className}`}>
        <MapContainer
          center={position}
          zoom={17}
          scrollWheelZoom={false}
          dragging={false}
          doubleClickZoom={false}
          touchZoom={false}
          zoomControl={false}
          className="h-full w-full"
        >
          <TileLayer url={OSM_TILE_URL} attribution={OSM_ATTRIBUTION} />
          <Marker position={position} icon={truckPinIcon} interactive={false} />
        </MapContainer>
      </div>
      <a
        href={directionsUrl(location)}
        target="_blank"
        rel="noreferrer"
        className="inline-flex items-center gap-1 text-sm font-medium text-primary hover:underline"
        data-testid="truck-directions-link"
      >
        <Navigation className="w-4 h-4" />
        Get directions
      </a>
    </div>
  );
}
